import { resolveFinding, useGetLocaleQuery } from '@consigli/hooks';
import { Button } from '@consigli/shadcn';
import { Finding } from '@consigli/types';
import { FC, useEffect, useRef, useState } from 'react';

interface FindingRowProps {
  finding: Finding;
}

export const FindingRow: FC<FindingRowProps> = ({ finding }) => {
  const { data: translations } = useGetLocaleQuery('en');
  const customMessage = finding.messageContext?.CUSTOM_MESSAGE;
  const displayText =
    (typeof customMessage === 'string' ? customMessage : undefined) ??
    resolveFinding(finding, translations) ??
    finding.fileName ??
    String(finding.id);
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [displayText]);

  return (
    <li className="list-none bg-white rounded-md border border-gray-200 px-4 py-3 text-sm text-gray-700 leading-relaxed flex items-start gap-3">
      <span className="flex flex-col items-start min-w-0 flex-1">
        <span
          ref={textRef}
          data-testid="finding-text"
          className={expanded ? undefined : 'line-clamp-3'}
        >
          {displayText}
        </span>
        {isClamped && (
          <Button
            variant="link"
            size="sm"
            onClick={() => setExpanded((v) => !v)}
            className="mt-1.5 px-0 h-auto text-xs text-gray-600"
          >
            {expanded ? 'Show less' : 'Show more'}
          </Button>
        )}
      </span>
    </li>
  );
};
